// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';
import Link from '../../../link';

const StyledLink = styled<typeof Link, Theme>(Link)`
  color: inherit;
  text-decoration: none;
  display: block;

  && {
    margin-bottom: 0;
  }
`;

// When Babel7 is released, let's use this:
// https://github.com/babel/babel/tree/7.0/packages/babel-plugin-transform-optional-chaining
const Wrapper = styled<any, Theme>('div')`
  border-radius: ${props => props.theme.carblock.borderRadius};
  background: transparent;
  height: auto;
  position: relative;
  margin: ${props => props.theme.carblock.wrapper.margin.sm};
  display: flex;
  flex-grow: 1;
  box-sizing: border-box;
  width: auto;

  &:hover,
  &:focus {
    text-decoration: none;
  }

  ${media.md(css`
    margin: ${props => props.theme.carblock.wrapper.margin.md};
    padding: auto;
  `)}
  ${media.lg(css`
    padding: auto;
  `)}
`;

export default ({ href, ...rest }: Object) => {
  if (href) {
    return <Wrapper as={StyledLink} {...rest} href={href} />;
  }
  return <Wrapper {...rest} />;
};
